import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BitbucketPlain = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M14.1024 14.9342H9.93749L8.80975 9.0424H15.1116L14.1024 14.9342ZM2.64886 3.00005C2.29516 2.99557 2.00458 3.27878 2.0001 3.63248C1.99946 3.66964 2.00202 3.70681 2.00811 3.74333L4.72812 20.2557C4.79797 20.6728 5.15743 20.9794 5.58033 20.9829H18.6294C18.9469 20.9871 19.2195 20.758 19.2701 20.4447L21.9902 3.74654C22.0469 3.39732 21.8095 3.06797 21.4602 3.01159C21.4237 3.0055 21.3866 3.00262 21.3494 3.00326L2.64886 3.00005Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default BitbucketPlain;
